export enum AirQualitySubType {
  AirQualityEmergencyWarningEntity = 'warnings_air-quality--emergency-warning',
  AirQualityWatchAndActWarningEntity = 'warnings_air-quality--watch-and-act',
  AirQualityAdviceWarningEntity = 'warnings_air-quality--advice',
}

export enum BlizzardSubType {
  BlizzardEmergencyWarningEntity = 'warnings_blizzard--emergency-warning',
  BlizzardWatchAndActWarningEntity = 'warnings_blizzard--watch-and-act',
  BlizzardAdviceWarningEntity = 'warnings_blizzard--advice',
}

export enum ExtremeColdSubType {
  ExtremeColdEmergencyWarningEntity = 'warnings_extreme-cold--emergency-warning',
  ExtremeColdWatchAndActWarningEntity = 'warnings_extreme-cold--watch-and-act',
  ExtremeColdAdviceWarningEntity = 'warnings_extreme-cold--advice',
}

export enum FlashFloodSubType {
  FlashFloodEmergencyWarningEntity = 'warnings_flash-flood--emergency-warning',
  FlashFloodWatchAndActWarningEntity = 'warnings_flash-flood--watch-and-act',
  FlashFloodAdviceWarningEntity = 'warnings_flash-flood--advice',
}

export enum FreezingRainSubType {
  FreezingRainEmergencyWarningEntity = 'warnings_freezing-rain--emergency-warning',
  FreezingRainWatchAndActWarningEntity = 'warnings_freezing-rain--watch-and-act',
  FreezingRainAdviceWarningEntity = 'warnings_freezing-rain--advice',
}

export enum IceJamSubType {
  IceJamEmergencyWarningEntity = 'warnings_ice-jam--emergency-warning',
  IceJamWatchAndActWarningEntity = 'warnings_ice-jam--watch-and-act',
  IceJamAdviceWarningEntity = 'warnings_ice-jam--advice',
}

export enum LakeFloodingSubType {
  LakeFloodingEmergencyWarningEntity = 'warnings_lake-flooding--emergency-warning',
  LakeFloodingWatchAndActWarningEntity = 'warnings_lake-flooding--watch-and-act',
  LakeFloodingAdviceWarningEntity = 'warnings_lake-flooding--advice',
}

export enum PowerOutageEmoSubType {
  PowerOutageWarningEntity = 'warnings_power-outage',
  PowerOutageEmergencyWarningEntity = 'warnings_power-outage--emergency-warning',
  PowerOutageWatchAndActWarningEntity = 'warnings_power-outage--watch-and-act',
}

export enum RiverFloodingSubType {
  RiverFloodingEmergencyWarningEntity = 'warnings_river-flooding--emergency-warning',
  RiverFloodingWatchAndActWarningEntity = 'warnings_river-flooding--watch-and-act',
  RiverFloodingAdviceWarningEntity = 'warnings_river-flooding--advice',
}

export enum SeasonalOverlandFloodingSubType {
  SeasonalOverlandFloodingEmergencyWarningEntity = 'warnings_seasonal-overland-flooding--emergency-warning',
  SeasonalOverlandFloodingWatchAndActWarningEntity = 'warnings_seasonal-overland-flooding--watch-and-act',
  SeasonalOverlandFloodingAdviceWarningEntity = 'warnings_seasonal-overland-flooding--advice',
}

export enum SevereWinterWeatherSubType {
  SevereWinterWeatherEmergencyWarningEntity = 'warnings_severe-winter-weather--emergency-warning',
  SevereWinterWeatherWatchAndActWarningEntity = 'warnings_severe-winter-weather--watch-and-act',
  SevereWinterWeatherAdviceWarningEntity = 'warnings_severe-winter-weather--advice',
}

export enum TornadoSubType {
  TornadoEmergencyWarningEntity = 'warnings_tornado--emergency-warning',
  TornadoWatchAndActWarningEntity = 'warnings_tornado--watch-and-act',
  TornadoAdviceWarningEntity = 'warnings_tornado--advice',
}

export enum BushfireSubType {
  BushfireAdviceWarningEntity = 'warnings_bushfire--advice',
  BushfireWatchAndActWarningEntity = 'warnings_bushfire--watch-and-act',
  BushfireEmergencyWarningWarningEntity = 'warnings_bushfire--emergency-warning',
}

export enum CoastalHazardSubType {
  CoastalHazardAdviceWarningEntity = 'warnings_coastal-hazard--advice',
  CoastalHazardWatchAndActWarningEntity = 'warnings_coastal-hazard--watch-and-act',
  CoastalHazardEmergencyWarningWarningEntity = 'warnings_coastal-hazard--emergency-warning',
}

export enum CycloneSubType {
  CycloneAdviceWarningEntity = 'warnings_cyclone--advice',
  CycloneWatchAndActWarningEntity = 'warnings_cyclone--watch-and-act',
  CycloneEmergencyWarningWarningEntity = 'warnings_cyclone--emergency-warning',
}

export enum DamagingWindsSubType {
  DamagingWindsAdviceWarningEntity = 'warnings_damaging-winds--advice',
  DamagingWindsWatchAndActWarningEntity = 'warnings_damaging-winds--watch-and-act',
  DamagingWindsEmergencyWarningWarningEntity = 'warnings_damaging-winds--emergency-warning',
}

export enum EarthquakeSubType {
  EarthquakeAlertWarningEntity = 'warnings_earthquake-alert',
  EarthquakeFinalAlertWarningEntity = 'warnings_earthquake-final-alert',
}

export enum FloodSubType {
  FloodAdviceWarningEntity = 'warnings_flood--advice',
  FloodWatchAndActWarningEntity = 'warnings_flood--watch-and-act',
  FloodEmergencyWarningWarningEntity = 'warnings_flood--emergency-warning',
}

export enum HazardSubType {
  HazmatGeneralWarningWarningEntity = 'warnings_hazmat-general-warning',
  HazmatControlledContainedWarningEntity = 'warnings_hazmat-controlled-contained',
}

export enum HeatwaveSubType {
  HeatwaveAdviceWarningEntity = 'warnings_heatwave--advice',
  HeatwaveWatchAndActWarningEntity = 'warnings_heatwave--watch-and-act',
  HeatwaveEmergencyWarningWarningEntity = 'warnings_heatwave--emergency-warning',
}

export enum HumanPandemicSubType {
  CommunityInformationWarningEntity = 'warnings_community-information',
  AdviceWarningEntity = 'warnings_advice',
  AlertWarningEntity = 'warnings_alert',
  WarningStateWideWarningEntity = 'warnings_state-wide-warning',
  WarningLocationSpecificWarningEntity = 'warnings_location-specific-warning',
}

export enum SmokeSubType {
  SmokeAlertWarningEntity = 'warnings_smoke-alert',
}

export enum StormSubType {
  StormAdviceWarningEntity = 'warnings_storm--advice',
  StormWatchAndActWarningEntity = 'warnings_storm--watch-and-act',
  StormEmergencyWarningWarningEntity = 'warnings_storm--emergency-warning',
}

export enum StormSurgeSubType {
  StormSurgeAdviceWarningEntity = 'warnings_storm-surge--advice',
  StormSurgeWatchAndActWarningEntity = 'warnings_storm-surge--watch-and-act',
  StormSurgeEmergencyWarningWarningEntity = 'warnings_storm-surge--emergency-warning',
}

export enum StructureFireSubType {
  StructureFireAdviceWarningEntity = 'warnings_structure-fire-advice',
  StructureFireAllClearWarningEntity = 'warnings_structure-fire-all-clear',
}

export enum TotalFireBanSubType {
  TotalFireBanWarningEntity = 'warnings_total-fire-ban',
  NoTotalFireBanWarningEntity = 'warnings_no-total-fire-ban',
}

export enum TsunamiSubType {
  TsunamiLandWarningWarningEntity = 'warnings_tsunami-land-warning',
  TsunamiMarineWarningWarningEntity = 'warnings_tsunami-marine-warning',
  TsunamiWatchWarningEntity = 'warnings_tsunami-watch',
  TsunamiAllClearWarningEntity = 'warnings_tsunami-all-clear',
}

export enum OtherWarningSubType {
  OtherWarningWarningEntity = 'warnings_other',
  OtherEmergencyWarningWarningEntity = 'warnings_other--emergency-warning',
  OtherWatchAndActWarningEntity = 'warnings_other--watch-and-act',
}

export const WarningSubTypes = {
  ...AirQualitySubType,
  ...BlizzardSubType,
  ...BushfireSubType,
  ...ExtremeColdSubType,
  ...FlashFloodSubType,
  ...FreezingRainSubType,
  ...IceJamSubType,
  ...LakeFloodingSubType,
  ...PowerOutageEmoSubType,
  ...RiverFloodingSubType,
  ...SeasonalOverlandFloodingSubType,
  ...SevereWinterWeatherSubType,
  ...TornadoSubType,
  ...CoastalHazardSubType,
  ...CycloneSubType,
  ...DamagingWindsSubType,
  ...EarthquakeSubType,
  ...FloodSubType,
  ...HazardSubType,
  ...HeatwaveSubType,
  ...HumanPandemicSubType,
  ...SmokeSubType,
  ...StormSubType,
  ...StormSurgeSubType,
  ...StructureFireSubType,
  ...TotalFireBanSubType,
  ...TsunamiSubType,
  ...OtherWarningSubType,
};

export type WarningSubType = (typeof WarningSubTypes)[keyof typeof WarningSubTypes];
